// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1FXLc","loaderOuter":"PageOverlayLoader_loaderOuter__1omZJ"};